export const SET_DICTCREDENTIAL = 'SET_DICTCREDENTIAL';
export const SET_DICTCREDENTIALS = 'SET_DICTCREDENTIALS';
export const SET_DICTCREDENTIALS_QUERY_PARAMS = 'SET_DICTCREDENTIALS_QUERY_PARAMS';
export const SET_DICTCREDENTIALS_SET_IS_FETCHING = 'SET_DICTCREDENTIALS_SET_IS_FETCHING';
